import api from '../../services/api';

// Lista usada antes do cadastro existir. Continua como reserva: se a API falhar,
// ainda nao estiver publicada ou devolver vazio, o usuario segue marcando Perdido.
export const DEFAULT_MOTIVOS_PERDA = [
  { id: '1', name: 'Prazo de entrega' },
  { id: '2', name: 'Mudança de prioridades' },
  { id: '3', name: 'Preço elevado' },
  { id: '4', name: 'Concorrência mais atraente' },
  { id: '5', name: 'Recomendação do arquiteto' },
  { id: '6', name: 'Necessidades não atendidas' },
  { id: '7', name: 'Comprou Madeira/Alumínio' },
  { id: '8', name: 'Prazo de Final de Ano' },
  { id: '9', name: 'Sem Retorno do Cliente' },
  { id: '10', name: 'Condição de Pagamento não atendida' },
  { id: '11', name: 'Permuta' },
];

export const MOTIVOS_PERDA_TIMEOUT_MS = 8000;

export function normalizeMotivosPerda(data) {
  if (!Array.isArray(data)) return [];
  return data
    .map((item) => ({ id: String(item?.id ?? ''), name: String(item?.name ?? '').trim() }))
    .filter((item) => item.id && item.name);
}

export async function loadMotivosPerdaVisiveis(client = api) {
  try {
    const response = await client.get('/motivos-perda', { timeout: MOTIVOS_PERDA_TIMEOUT_MS });
    const motivos = normalizeMotivosPerda(response?.data);
    return motivos.length ? motivos : DEFAULT_MOTIVOS_PERDA;
  } catch (error) {
    return DEFAULT_MOTIVOS_PERDA;
  }
}
